import { render, staticRenderFns } from "./AddMenu.vue?vue&type=template&id=f6737408&scoped=true"
import script from "./AddMenu.vue?vue&type=script&lang=js"
export * from "./AddMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6737408",
  null
  
)

export default component.exports